const { breakpoints } = embark;

(() => {
	const eligibleChildren = [
		'em-call-to-action',
	];
	const postContent = document.querySelector('.post-content');
	let contentContainer = document.querySelector('.site-content');
	let lastChild = null;
	if (postContent) {
		contentContainer = postContent;
	}
	for (let i = 0; i < eligibleChildren.length; i++) {
		if (contentContainer.lastElementChild.classList.contains(eligibleChildren[i])) {
			lastChild = contentContainer.querySelector(`.${eligibleChildren[i]}:last-child`);
			break;
		}

		// Check if last child is nested with the last child of the content Container
		if (contentContainer.lastElementChild.querySelector(`.${eligibleChildren[i]}:last-child`)) {
			lastChild = contentContainer.lastElementChild.querySelector(`.${eligibleChildren[i]}:last-child`);
			break;
		}
	}

	if (lastChild) {
		const overlapFooter = () => {
			const site = document.querySelector('.site');
			const mainContent = document.getElementById('main-content');
			site.classList.add('overlap-main');
			const deepFooter = document.querySelector('.deep-footer');

			if (deepFooter) {
				let deepFooterEl = document.querySelector('.site-footer__before-deep-footer');

				// If deep footer element doesnt exist create it.
				if (!deepFooterEl) {
					const lastChildClone = lastChild.cloneNode(true);
					lastChildClone.classList.add('site-footer__before-deep-footer');
					lastChild.remove();
					deepFooter.parentNode.insertBefore(lastChildClone, deepFooter);
					deepFooterEl = lastChildClone;
				}

				const deepFooterElHeight = deepFooterEl.offsetHeight;
				deepFooter.parentNode.style.zIndex = '11';

				let extraPadding = 80;
				if (breakpoints.below('md')) {
					extraPadding = 40;
				}
				console.log('padding applied');

				// If main content last child is a background block add padding to it
				const mainContentLastChild = mainContent.querySelector('.site-content .wp-block-emagine-background:last-child');
				if (mainContentLastChild) {
					mainContentLastChild.style.setProperty('padding-bottom', `${(deepFooterElHeight * 0.5) + extraPadding}px`, 'important');
				} else {
					mainContent.style.setProperty('padding-bottom', `${(deepFooterElHeight * 0.5) + extraPadding}px`, 'important');
				}
				document.querySelector('.site-content>*:last-child').style.setProperty('margin-bottom', '0', 'important');
				deepFooterEl.style.setProperty('margin-top', `-${deepFooterElHeight * 0.5}px`, 'important');
			}
		};

		overlapFooter();
		window.addEventListener('resize', () => {
			window.requestAnimationFrame(() => {
				overlapFooter();
			});
		});
	}
})();
